export const en = {
  translation: {
    post: "post",
    remove_post: "Remove post",
    removed_post: "Removed post",
    restore_post: "Restore post",
    restored_post: "Restored post",
    lock_post: "Lock post",
    unlock_post: "Unlock post",
    no_posts: "No posts.",
    create_a_post: "Create a post",
    create_post: "Create post",
    denied: "Denied",
    number_of_posts: "{{formattedCount}} post",
    number_of_posts_plural: "{{formattedCount}} posts",
    posts: "Posts",
    related_posts: "These posts might be related",
    cross_posts: "This link has also been posted to:",
    cross_post: "Cross-post",
    cross_posted_to: "cross-posted to: ",
    cross_posted_from_url: "cross-posted from: {{ap_id}}",
    share_post: "Share post",
    comments: "Comments",
    number_of_comments: "{{formattedCount}} comment",
    number_of_comments_plural: "{{formattedCount}} comments",
    remove_comment: "Remove comment",
    removed_comment: "Removed comment",
    remove_content: "Remove content",
    restore_comment: "Restore comment",
    restored_comment: "Restored comment",
    restored_community: "Restored community",
    restored_multi_community: "Restored multi-community",
    lock_comment: "Lock comment",
    unlock_comment: "Unlock comment",
    remove_content_more: "Remove posts, comments, and communities",
    comment_here: "Type here to comment...",
    communities: "Communities",
    all_communities: "All communities",
    users: "Users",
    all_users: "All users",
    warn_user: "Warn user",
    warning_sent: "Warning sent",
    create_a_community: "Create a community",
    select_a_community: "Select a community",
    create_community: "Create community",
    remove_community: "Remove community",
    restore_community: "Restore community",
    add_community: "Add a community",
    explore_communities: "Explore communities",
    visit_random_community: "Visit a random community",
    subscribed_to_communities: "Subscribed to <1>communities</1>",
    trending_communities: "Trending <1>communities</1>",
    trending: "Trending",
    list_of_communities: "List of communities",
    number_of_communities: "{{formattedCount}} community",
    number_of_communities_plural: "{{formattedCount}} communities",
    community_reqs: "Letters, numbers and no spaces",
    invalid_community_name: "Invalid name.",
    create_private_message: "Create private message",
    send_secure_message: "Send secure message",
    send_message: "Send message",
    message: "Message",
    edit: "Edit",
    edit_as_mod: "Edit as mod",
    add: "Add",
    reply: "Reply",
    more: "More",
    cancel: "Cancel",
    preview: "Preview",
    upload_image: "upload image",
    uploader: "Uploader",
    uploads: "Uploads",
    too_many_images_upload: "Exceeded maximum of {{formattedCount}} image to upload. Please select only one image.",
    too_many_images_upload_plural: "Exceeded maximum of {{formattedCount}} images to upload. Please select fewer images.",
    avatar: "Avatar",
    upload_avatar: "Upload avatar",
    banner: "Banner",
    upload_banner: "Upload banner",
    icon: "Icon",
    upload_icon: "Upload icon",
    upload_too_large: "Uploaded image is too large!",
    show_avatars: "Show avatars",
    show_media: "Show media",
    show_scores: "Show scores",
    show_upvotes: "Show upvotes",
    show_downvotes: "Show downvotes",
    show_upvote_percentage: "Show upvote %",
    bot_account: "Bot account",
    show_bot_accounts: "Show bot accounts",
    show_read_posts: "Show read posts",
    hide_read_posts: "Hide read posts",
    show_context: "Show context",
    formatting_help: "formatting help",
    sorting_help: "sorting help",
    view_source: "View source",
    view_all_comments: "View all comments",
    unlock: "Unlock",
    lock: "Lock",
    sticky: "sticky",
    unsticky: "unsticky",
    link: "Link",
    fedilink: "Fedilink",
    archive_link: "archive link",
    bold: "bold",
    italic: "italic",
    subscript: "subscript",
    superscript: "superscript",
    header: "header",
    strikethrough: "strikethrough",
    quote: "quote",
    spoiler: "spoiler",
    list: "List",
    card: "Card",
    small_card: "Small card",
    mod: "mod",
    mods: "Mods",
    all_mods: "All mods",
    distinguish: "Speak as moderator",
    undistinguish: "Speak as user",
    distinguished_comment: "Distinguished comment",
    undistinguished_comment: "Undistinguished comment",
    moderates: "Moderates",
    settings: "Settings",
    admin_settings: "Admin settings",
    x_settings: "<1>item</1> settings",
    cannot_leave_admin: "You cannot leave the server without an admin",
    leave_admin_team: "Leave the admin team",
    left_admin_team: "You have left the admin team",
    left_mod_team: "You have left the mod team",
    profile: "Profile",
    profile_not_logged_in_alert: "You are not logged in. If you use a Fediverse account that is able to follow users, you can follow this user.",
    community_not_logged_in_alert: "You are not logged in. However you can subscribe from another Fediverse account, for example Lemmy or Mastodon. To do this, paste the following into the search field of your instance: <1>!{{community}}@{{instance}}</1>",
    site_config: "Site configuration",
    remove_as_mod: "Remove as mod",
    remove_as_mod_are_you_sure: "Are you sure you want to remove {{user}} as a moderator for {{community}}?",
    removed_mod: "Removed moderator",
    removing_mod: "Removing mod",
    appoint_as_mod: "Appoint as moderator",
    appoint_mod: "Appoint moderator",
    appointing_mod: "Appointing moderator",
    appointed_mod: "Appointed moderator",
    appoint_as_mod_are_you_sure: "Are you sure you want to appoint {{user}} as a moderator for {{community}}?",
    leave_mod_team: "Leave mod team",
    modlog: "Modlog",
    filter_by_action: "Filter by action",
    filter_by_mod: "Filter by mod",
    filter_by_user: "Filter by user",
    removing_posts: "Removing posts",
    locking_posts: "Locking posts",
    locking_comments: "Locking comments",
    featuring_posts_in_community: "Featuring posts in community",
    featuring_posts_for_local_instance: "Featuring posts for local instance",
    removing_comments: "Removing comments",
    removing_communities: "Removing communities",
    banning_from_site: "Banning from site",
    banning_from_communities: "Banning from communities",
    adding_mod_to_community: "Adding mod to community",
    transferring_communities: "Transferring communities",
    changing_community_visibility: "Changing community visibility",
    adding_admin_to_site: "Adding admin to site",
    blocking_a_federated_instance: "Blocking a federated instance",
    allowing_a_federated_instance: "Allowing a federated instance",
    purging_a_person: "Purging a person",
    purging_a_community: "Purging a community",
    purging_a_post: "Purging a post",
    purging_a_comment: "Purging a comment",
    admin: "admin",
    admins: "admins",
    remove_as_admin: "Remove as admin",
    remove_as_admin_are_you_sure: "Are you sure you want to remove {{user}} from the {{instance}} admin team?",
    removing_admin: "Removing admin",
    removed_admin: "Removed admin",
    appoint_as_admin: "Appoint as admin",
    appointing_admin: "Appointing admin",
    appointed_admin: "Appointed admin",
    appoint_as_admin_are_you_sure: "Are you sure you want to appoint {{user}} as an admin of {{instance}}?",
    only_admins_can_create_communities: "Only admins can create communities",
    only_mods_can_post_in_community: "Only moderators can post to this community",
    remove: "Remove",
    removing: "Removing",
    removed: "Removed by mod",
    locked: "Locked",
    unlocked: "Unlocked",
    locking: "Locking",
    unlocking: "Unlocking",
    locked_post: "Locked post",
    locked_post_comment_placeholder: "This content is locked, you can not comment.",
    unlocked_post: "Unlocked post",
    loading: "Loading",
    stickied: "stickied",
    reason: "Reason",
    mark_as_read: "Mark as read",
    mark_as_unread: "Mark as unread",
    delete: "Delete",
    deleted_post: "Deleted post",
    deleted_comment: "Deleted comment",
    deleted_community: "Deleted community",
    deleted_multi_community: "Deleted multi-community",
    undelete: "Undelete",
    undeleted_post: "Undeleted post",
    undeleted_comment: "Undeleted comment",
    deleted: "deleted by creator",
    delete_account: "Delete account",
    delete_account_content: "Delete all posts, comments and uploaded images",
    delete_account_confirm: "Warning: this will permanently delete your account. The deletion may not always federate to other instances. Enter your password to confirm.",
    click_to_delete_picture: "Click to delete picture: {{filename}}",
    failed_to_delete_picture: "Failed to delete picture: {{filename}}",
    picture_deleted: "Picture deleted: {{filename}}",
    pictures_uploaded_progress: "{{uploaded}}/{{total}} pictures uploaded",
    restore: "Restore",
    restoring: "Restoring",
    permanently_ban: "Permanently ban",
    ban: "Ban",
    ban_with_name: "Ban {{user}}",
    banning: "Banning {{user}}",
    ban_from_site: "Ban from site",
    ban_from_community: "Ban from community",
    ban_from_community_with_name: "Ban {{user}} from {{community}}",
    unban: "Unban",
    unban_with_name: "Unban {{user}}",
    unbanning: "Unbanning {{user}}",
    unban_from_site: "Unban from site",
    unban_from_community: "Unban from community",
    unban_from_community_with_name: "Unban {{user}} from {{community}}",
    banned: "Banned",
    banned_from_community_badge: "Banned from community",
    banned_users: "Banned users",
    banned_from_community: "Banned {{user}} from {{community}}",
    unbanned_from_community: "Unbanned {{user}} from {{community}}",
    banned_from_site: "Banned {{user}}",
    unbanned_from_site: "Unbanned {{user}}",
    purge: "Purge",
    purging: "Purging",
    purge_post: "Purge post",
    purge_comment: "Purge comment",
    purge_community: "Purge community",
    purge_community_with_name: "Purge {{community}}",
    purge_user: "Purge user",
    purge_user_with_name: "Purge {{user}}",
    purge_warning: "Warning: Purging will delete this item, and all its children from the database. You will not be able to recover the data. Use with extreme caution.",
    modlog_content_warning: "<1>CONTENT WARNING</1>: Some deleted posts may contain disturbing or adult material. Proceed with caution.",
    purge_success: "The item has been successfully purged.",
    save: "Save",
    unsave: "Unsave",
    create: "Create",
    creator: "Creator",
    all_creators: "All creators",
    username: "Username",
    email_or_username: "Email or username",
    number_of_users: "{{formattedCount}} user",
    number_of_users_plural: "{{formattedCount}} users",
    number_of_subscribers: "{{formattedCount}} subscriber",
    number_of_subscribers_plural: "{{formattedCount}} subscribers",
    number_of_local_subscribers: "{{formattedCount}} local subscriber",
    number_of_local_subscribers_plural: "{{formattedCount}} local subscribers",
    number_of_points: "{{formattedCount}} point",
    number_of_points_plural: "{{formattedCount}} points",
    name: "Name",
    name_explain: "Name – used as the identifier for the community, cannot be changed.",
    display_name: "Display name",
    display_name_explain: "Display name — shown as the title on the community's page, can be changed.",
    title: "Title",
    subscribers: "Subscribers",
    both: "Both",
    saved: "Saved",
    unsubscribe: "Unsubscribe",
    subscribe: "Subscribe",
    subscribed: "Subscribed",
    subscribe_pending: "Subscribe pending",
    subscribed_description: "Shows the communities you've subscribed to",
    prev: "Prev",
    next: "Next",
    sidebar: "Sidebar",
    description: "Description",
    sort_type: "Sort type",
    post_sort_type: "Post sort type",
    comment_sort_type: "Comment sort type",
    sort: "Sort",
    listing_type: "Listing type",
    listing_mode: "Listing mode",
    hot: "Hot",
    active: "Active",
    active_users_in_the_last_day: "{{formattedCount}} active user in the last day",
    active_users_in_the_last_day_plural: "{{formattedCount}} active users in the last day",
    active_users_in_the_last_week: "{{formattedCount}} active user in the last week",
    active_users_in_the_last_week_plural: "{{formattedCount}} active users in the last week",
    active_users_in_the_last_month: "{{formattedCount}} active user in the last month",
    active_users_in_the_last_month_plural: "{{formattedCount}} active users in the last month",
    active_users_in_the_last_six_months: "{{formattedCount}} active user in the last 6 months",
    active_users_in_the_last_six_months_plural: "{{formattedCount}} active users in the last 6 months",
    scaled: "Scaled",
    very_weak: "Very weak",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    new: "New",
    old: "Old",
    one_hour: "One hour",
    six_hours: "Six hours",
    twelve_hours: "Twelve hours",
    one_day: "One day",
    one_week: "One week",
    one_month: "One month",
    three_months: "Three months",
    six_months: "Six months",
    nine_months: "Nine months",
    one_year: "One year",
    all_time: "All time",
    custom_time: "Custom time interval",
    most_comments: "Most comments",
    new_comments: "New comments",
    seconds: "Seconds",
    day: "Day",
    days: "Days",
    minutes: "Minutes",
    hours: "Hours",
    week: "Week",
    weeks: "Weeks",
    month: "Month",
    months: "Months",
    years: "Years",
    n_seconds: "{{formattedCount}} second",
    n_seconds_plural: "{{formattedCount}} seconds",
    n_minutes: "{{formattedCount}} minute",
    n_minutes_plural: "{{formattedCount}} minutes",
    n_hours: "{{formattedCount}} hour",
    n_hours_plural: "{{formattedCount}} hours",
    n_days: "{{formattedCount}} day",
    n_days_plural: "{{formattedCount}} days",
    n_months: "{{formattedCount}} month",
    n_months_plural: "{{formattedCount}} months",
    n_weeks: "{{formattedCount}} week",
    n_weeks_plural: "{{formattedCount}} weeks",
    n_years: "{{formattedCount}} year",
    n_years_plural: "{{formattedCount}} years",
    time_interval: "Time interval",
    time_unit: "Time unit",
    time_filter: "Time",
    update: "Update",
    number_of_months: "{{formattedCount}} month",
    number_of_months_plural: "{{formattedCount}} months",
    number_of_days: "Number of days",
    all: "All",
    all_description: "Shows all communities, including federated ones",
    local: "Local",
    local_description: "Shows only local communities",
    moderator_view: "Moderator view",
    moderator_view_description: "Only show contributions from communtities you are a moderator of",
    read_terms_and_conditions: "I agree to the terms and conditions.",
    top: "Top",
    api: "API",
    docs: "Docs",
    inbox: "Inbox",
    inbox_for: "Inbox for <1>{{user}}</1>",
    mark_all_as_read: "mark all as read",
    type: "Type",
    read: "Read",
    unread: "Unread",
    show_unread_only: "Show unread only",
    show_unresolved_only: "Show unresolved only",
    replies: "Replies",
    x_more_replies: "{{formattedCount}} more reply",
    x_more_replies_plural: "{{formattedCount}} more replies",
    mentions: "Mentions",
    reply_sent: "Reply sent",
    message_sent: "Message sent",
    search: "Search",
    overview: "Overview",
    view: "View",
    upvoted: "Upvoted",
    logout: "Logout",
    login_sign_up: "Login / Sign up",
    login: "Login",
    sign_up: "Sign Up",
    notifications: "Notifications",
    notifications_error: "Desktop notifications not available in your browser. Try Firefox or Chrome.",
    error_page_title: "Error!",
    error_page_paragraph: "There was an error on the server. Try refreshing your browser. If that doesn't work, come back at a later time. If the problem persists, you can seek help in the <1>Lemmy support community</1> or <2>Lemmy Matrix room</2>.",
    error_page_admin_matrix: "If you would like to reach out to one of {{instance}} admins for support, try the following Matrix addresses:",
    error_code_message: "The server returned this error: <1>{{error}}</1>. This may be useful for admins and developers to diagnose and fix the error",
    not_found_page_title: "Page not found",
    not_found_page_message: "The page you are looking for does not exist.",
    not_found_return_home_button: "Click here to return to your homepage",
    websocket_disconnected: "Websocket disconnected",
    websocket_reconnected: "Websocket reconnected",
    unread_messages: "{{formattedCount}} Unread Message",
    unread_messages_plural: "{{formattedCount}} Unread Messages",
    unread_reports: "{{formattedCount}} Unread Report",
    unread_reports_plural: "{{formattedCount}} Unread Reports",
    unread_registration_applications: "{{formattedCount}} Unread Application",
    unread_registration_applications_plural: "{{formattedCount}} Unread Applications",
    messages: "Messages",
    password: "Password",
    change_password: "Change password",
    password_changed: "Password changed.",
    invalid_password: "Password length must be between 10 and 60 characters.",
    verify_password: "Verify password",
    old_password: "Old password",
    forgot_password: "Forgot password",
    reset_password_mail_sent: "Sent an email to reset your password.",
    password_change: "Password change",
    new_password: "New password",
    no_email_setup: "This server hasn't correctly set up email.",
    email: "Email",
    matrix_user_id: "Matrix user",
    invalid_matrix_id: "Invalid matrix id. Must be @user:instance.tld",
    private_message_disclaimer: "Warning: Private messages in Lemmy are not end-to-end encrypted, so the sender and recipient's instance admins are technically able to read them. Please consider using <1>Matrix</1> for sensitive messages.",
    send_notifications_to_email: "Send notifications to email",
    optional: "Optional",
    expires: "Expires",
    days_until_expiration: "Days until expiration",
    interface_language: "Interface language",
    language: "Language",
    language_plural: "Languages",
    language_select_placeholder: "Select language",
    undetermined_language_warning: "Warning: If you deselect undetermined, you will not see most content.",
    language_browser_default: "Browser default",
    theme_instance_default: "Instance default",
    theme_instance_default_compact: "Instance default (compact)",
    downvotes_disabled: "Downvotes disabled",
    enable_downvotes: "Enable downvotes",
    upvote: "Upvote",
    number_of_upvotes: "{{formattedCount}} upvote",
    number_of_upvotes_plural: "{{formattedCount}} upvotes",
    downvote: "Downvote",
    number_of_downvotes: "{{formattedCount}} downvote",
    number_of_downvotes_plural: "{{formattedCount}} downvotes",
    upvote_percentage: "{{formattedCount}}% upvoted",
    view_votes: "View votes",
    votes: "Votes",
    registration_mode: "Registration mode",
    open_registration: "Open registration",
    close_registration: "Close registration",
    registration_closed: "Registration closed",
    enable_nsfw: "Enable NSFW",
    disallow_nsfw_content: "Disallow NSFW content",
    url: "URL",
    body: "Body",
    custom_thumbnail_url: "Thumbnail URL",
    copy_suggested_title: "copy suggested title: {{title}}",
    suggested: "Suggested",
    tree: "Tree",
    community: "Community",
    expand_here: "Expand here",
    subscribe_to_communities: "Subscribe to some <1>communities</1>.",
    chat: "Chat",
    recent_comments: "Recent comments",
    no_results: "No results.",
    setup: "Setup",
    lemmy_instance_setup: "Lemmy instance setup",
    setup_admin: "Set up site administrator",
    community_creation_admin_only: "Only admins can create communities",
    setup_your_site: "Setup your site",
    edit_your_site: "Edit your site",
    created: "created",
    modified: "modified",
    nsfw: "NSFW",
    show_nsfw: "Show NSFW content",
    theme: "Theme",
    code: "Code",
    joined: "Joined",
    join_lemmy: "Join Lemmy",
    support_lemmy: "Support Lemmy",
    by: "by",
    to: "to",
    from: "from",
    transfer_community: "Transfer community",
    transferring_community: "Transferring community",
    transfer_community_are_you_sure: "Are you sure you want to transfer {{community}} to {{user}}?",
    transfer_site: "Transfer site",
    transferred_community: "Community transferred",
    are_you_sure: "are you sure?",
    yes: "Yes",
    no: "No",
    not_logged_in: "Not logged in.",
    stay_logged_in: "Stay logged in",
    bio_length_overflow: "User bio cannot exceed 1000 characters.",
    logged_in: "Logged in.",
    must_login: "You must <1>log in</1> or <2>register</2> to comment.",
    site_saved: "Site saved.",
    community_ban: "You have been banned from this community.",
    site_ban: "You have been banned from the site",
    couldnt_find_comment: "Couldn't find comment.",
    couldnt_create_comment: "Couldn't create comment.",
    couldnt_like_comment: "Couldn't like comment.",
    couldnt_update_comment: "Couldn't update comment.",
    couldnt_save_comment: "Couldn't save comment.",
    couldnt_get_comments: "Couldn't get comments.",
    no_comment_edit_allowed: "Not allowed to edit comment.",
    no_post_edit_allowed: "Not allowed to edit post.",
    no_community_edit_allowed: "Not allowed to edit community.",
    couldnt_find_community: "Couldn't find community.",
    couldnt_update_community: "Couldn't update community.",
    community_already_exists: "Community already exists.",
    community_moderator_already_exists: "Community moderator already exists.",
    community_follower_already_exists: "Community follower already exists.",
    community_user_already_banned: "Community user already banned.",
    couldnt_create_post: "Couldn't create post.",
    couldnt_like_post: "Couldn't like post.",
    couldnt_find_post: "Couldn't find post.",
    couldnt_get_posts: "Couldn't get posts",
    couldnt_update_post: "Couldn't update post",
    couldnt_save_post: "Couldn't save post.",
    couldnt_mark_post_as_read: "Couldn't mark post as read.",
    couldnt_find_parent_comment: "Couldn't find parent comment.",
    parent_comment_not_in_post: "The parent comment belongs to another post.",
    no_slurs: "No slurs.",
    not_an_admin: "Not an admin.",
    not_a_moderator: "Not a moderator.",
    not_a_mod_or_admin: "Not a moderator or admin.",
    site_already_exists: "Site already exists.",
    site_name_required: "Site name required.",
    site_name_length_overflow: "Site name cannot exceed 20 characters",
    site_description_length_overflow: "Site description cannot exceed 150 characters.",
    couldnt_update_site: "Couldn't update site.",
    couldnt_find_that_username_or_email: "Couldn't find that username or email.",
    password_incorrect: "Password incorrect.",
    passwords_dont_match: "Passwords do not match.",
    no_password_reset: "You will not be able to reset your password without an email.",
    captcha_incorrect: "Captcha incorrect.",
    enter_code: "Enter code",
    invalid_username: "Invalid username.",
    admin_already_created: "Sorry, there's already an admin.",
    user_already_exists: "User already exists.",
    username_already_exists: "Username already exists.",
    email_already_exists: "Email already exists.",
    couldnt_update_user: "Couldn't update user.",
    system_err_login: "System error. Try logging out and back in.",
    rate_limit_error: "Too many requests, try again later.",
    couldnt_create_private_message: "Couldn't create private message.",
    no_private_message_edit_allowed: "Not allowed to edit private message.",
    couldnt_update_private_message: "Couldn't update private message.",
    time: "Time",
    post_time_range: "Show posts from last",
    action: "Action",
    emoji_picker: "Emoji picker",
    block_leaving: "Are you sure you want to leave?",
    what_is: "What is",
    cake_day_title: "Cake day:",
    cake_day_info: "It's {{creator_name}}'s cake day today!",
    invalid_post_title: "Invalid post title",
    invalid_url: "Invalid URL.",
    play_captcha_audio: "Play captcha audio",
    bio: "Bio",
    instances: "Instances",
    linked_instances: "Linked instances",
    allowed_instances: "Allowed instances",
    blocked_instances: "Blocked instances",
    block_instance: "Block instance",
    unblock_instance: "Unblock instance",
    allow_instance: "Allow instance",
    blocked_all_communities_from_these_instances: "Blocked all communities from these instances",
    blocked_all_users_from_these_instances: "Blocked all users from these instances",
    blocked_all_communities_from: "Blocked all communities from {{instance}}",
    blocked_all_users_from: "Blocked all users from {{instance}}",
    blocked_users: "Blocked users",
    block_user: "Block user",
    blocked_communities: "Blocked communities",
    blocked: "Blocked",
    blocked_x: "Blocked {{item}}",
    unblocked: "Unblocked",
    unblocked_x: "Unblocked {{item}}",
    allowed_x: "Allowed {{item}}",
    disallowed_x: "Disallowed {{item}}",
    block_community: "Block community",
    unblock_user: "Unblock user",
    unblock_community: "Unblock community",
    blocks: "Blocks",
    keyword_blocks: "Keyword blocks",
    keyword_blocks_placeholder: "Enter any keywords you'd like to block from your feed, one block per line.",
    person_block: "This user has blocked you.",
    none_found: "None found.",
    report_reason_required: "Report reason required.",
    report_too_long: "Report too long.",
    couldnt_create_report: "Couldn't create report.",
    couldnt_resolve_report: "Couldn't resolve report.",
    expand: "Expand",
    collapse: "Collapse",
    collapse_bot_comments: "Collapse bot comments",
    captcha: "Captcha",
    reports: "Reports",
    reporter: "Reporter",
    resolved_by: "Resolved by <1></1>",
    reset_password: "Reset password",
    unresolved_by: "Unresolved by <1></1>",
    show_report_dialog: "Show report dialog",
    create_report: "Create report",
    creating_report: "Creating report",
    resolve_report: "Resolve report",
    unresolve_report: "Unresolve report",
    report_created: "Report created.",
    report_post: "Report post",
    report_comment: "Report comment",
    report_message: "Report message",
    report_community: "Report community",
    fill_out_application: "To join this server, you need to fill out this application, and wait to be accepted.",
    answer: "Answer",
    verify_email: "Verify email",
    verify_email_sent: "Verification email sent.",
    resend_verification_email: "Resend verification email",
    registration_application_sent: "Registration application sent.",
    application_questionnaire: "Application questionnaire",
    require_email_verification: "Require email verification",
    require_registration_application: "Require registration application",
    application_email_reason_none: "Application denied",
    application_email_admins: "Email admins on receiving new applications",
    reports_email_admins: "Email admins on receiving new reports",
    private_instance: "Private instance",
    registration_application_pending: "Registration approval pending.",
    registration_denied: "Registration application denied.",
    email_not_verified: "Email not verified.",
    email_verified: "Your email has been verified.",
    email_required: "Email required.",
    disable_email_notifications: "Disable email notifications",
    registration_application_answer_required: "Registration application required.",
    instance_is_private: "This instance is private.",
    apply_to_join: "Apply to join",
    registration_applications: "Registration applications",
    applicant: "Applicant",
    deny_reason: "Deny reason",
    approved_by: "Approved by <1></1>",
    denied_by: "Denied by <1></1>",
    approve: "Approve",
    deny: "Deny",
    required: "Required",
    default_theme: "Default theme",
    legal_information: "Legal",
    hide_modlog_mod_names: "Hide modlog mod names",
    slur_filter_regex: "Slur filter regex",
    invalid_regex: "Invalid regular expression.",
    permissive_regex: "Regular expression would match any provided text.",
    actor_name_max_length: "Max actor name length",
    federation_enabled: "Federation enabled",
    federation_debug: "Federation debug mode",
    federation_strict_allowlist: "Federation strict allowlist",
    federation_http_fetch_retry_limit: "Federation HTTP fetch retry limit",
    federation_worker_count: "Federation worker count",
    easy: "Easy",
    hard: "Hard",
    rate_limit: "Rate limit",
    rate_limit_message: "Message",
    rate_limit_post: "Post",
    rate_limit_register: "Register",
    rate_limit_image: "Image",
    rate_limit_comment: "Comment",
    rate_limit_search: "Search",
    rate_limit_import_user_settings: "Import settings",
    rate_limit_header: "Rate limit options",
    rate_limit_info: "Lemmy can limit requests per IP address for various actions. The rate limit field is how many times that IP address can perform that action, and per second is the number of seconds before the rate limit resets.",
    per_second: "Per second",
    taglines: "Taglines",
    add_tagline: "Add tagline",
    tagline_updated: "Tagline updated",
    tagline_deleted: "Tagline deleted",
    tagline_created: "Tagline created",
    couldnt_create_tagline: "Couldn't create tagline",
    couldnt_update_tagline: "Couldn't update tagline",
    couldnt_delete_tagline: "Couldn't delete tagline",
    community_tag_edited: "Community tag edited",
    community_tag_deleted: "Community tag deleted",
    community_tag_created: "Community tag created",
    featured: "Featured",
    featured_in_local: "Featured in local",
    featured_in_community: "Featured in community",
    feature_in_local: "Feature in local",
    unfeature_from_local: "Unfeature in local",
    feature_in_community: "Feature in community",
    unfeature_from_community: "Unfeature in community",
    featured_post: "Featured post",
    unfeatured_post: "Unfeatured post",
    deleted_emoji: "Deleted emoji",
    saved_emoji: "Saved emoji",
    custom_emoji_save_validation: "All fields must be filled in and shortcode can't be duplicated.",
    add_custom_emoji: "Add custom emoji",
    custom_emoji_updated: "Custom emoji updated",
    custom_emoji_deleted: "Custom emoji deleted",
    custom_emoji_created: "Custom emoji created",
    couldnt_create_custom_emoji: "Couldn't create custom emoji",
    couldnt_update_custom_emoji: "Couldn't update custom emoji",
    couldnt_delete_custom_emoji: "Couldn't delete custom emoji",
    column_keywords: "Keywords (space separated)",
    column_alttext: "Alt text",
    column_imageurl: "Image URL",
    column_shortcode: "Shortcode",
    column_category: "Category",
    column_emoji: "Emoji",
    custom_emojis: "Custom emojis",
    emojis: "Emojis",
    emoji: "Emoji",
    site: "Site",
    software: "Software",
    version: "Version",
    invalid_totp_code: "Invalid 2FA code: Must be string of six digits",
    incorrect_totp_code: "Incorrect 2FA code",
    enable_totp: "Enable 2-factor authentication",
    enter_totp_code: "Enter your 2FA code",
    totp_link: "Click here for 2FA installation link",
    disable_totp: "Disable 2-factor authentication",
    totp_qr: "2-factor authentication QR code",
    totp_qr_segue: "or scan this QR code in an authenticator app",
    enable_totp_success: "Successfully enabled 2-factor authentication",
    disable_totp_success: "Successfully disabled 2-factor authentication",
    jump_to_content: "Jump to content",
    cant_enable_private_instance_and_federation_together: "Can't enable private instance and federation together",
    remove_instance: "Remove instance",
    add_instance: "Add instance",
    open_links_in_new_tab: "Open links in a new tab",
    op: "OP",
    couldnt_create_audio_captcha: "Couldn't create audio captcha.",
    incorrect_login: "Incorrect login credentials",
    show_password: "Show password",
    hide_password: "Hide password",
    controversial: "Controversial",
    remote_follow_prompt: "Enter the instance you would like to follow this community from",
    fetch_community: "Fetch community",
    community_federated: "Community federated!",
    community_added: "Community added",
    community_removed: "Community removed",
    fetching_community: "Fetching {{community}}",
    could_not_fetch_community: "Could not fetch {{community}}",
    remote_follow: "Remote follow",
    remote_follow_modal_title: "Subscribe from remote instance",
    blur_nsfw: "Blur NSFW content",
    auto_expand: "Auto expand media",
    remote_follow_invalid_instance: "{{instance}} is not a valid domain.",
    remote_follow_local_instance: "Cannot fetch local instance for remote follow",
    domain: "Domain",
    import_export_section_title: "Import/Export settings",
    import_export_section_description: "Import and export your account settings as JSON",
    export_file_name: "lemmy_user_settings",
    export: "Export",
    import: "Import",
    exporting: "Exporting",
    importing: "Importing",
    import_export_rate_limit_error: "Please wait a few minutes before trying to import or export settings again",
    export_error: "Error exporting settings",
    import_error: "Error importing settings",
    import_success: "Settings successfully imported!",
    confirmation_required: "Confirmation required",
    submit: "Submit",
    authentication: "Authentication",
    oauth_config: "OAuth configuration",
    oauth_providers: "Providers",
    add_oauth_provider: "Add provider",
    oauth_provider_presets: "Preset providers",
    no_oauth_providers_blurb: "No providers",
    delete_oauth_provider_are_you_sure: "Are you sure you want to delete this provider?",
    deleting_oauth_provider: "Deleting provider...",
    oauth_display_name: "Display name",
    oauth_issuer: "Issuer",
    oauth_authorization_endpoint: "Authorization endpoint",
    oauth_token_endpoint: "Token endpoint",
    oauth_userinfo_endpoint: "User info endpoint",
    oauth_id_claim: "ID claim",
    oauth_client_id: "Client ID",
    oauth_client_secret: "Client secret",
    cannot_view_secret_after_saving: "Cannot view secret after saving",
    oauth_scopes: "OAuth scopes",
    oauth_auto_verify_email: "Auto-verify email",
    oauth_account_linking_enabled: "Enable account linking",
    oauth_enabled: "Enable provider",
    couldnt_edit_oauth_provider: "Couldn't edit OAuth provider.",
    couldnt_delete_oauth_provider: "Couldn't delete OAuth provider.",
    couldnt_create_oauth_provider: "Couldn't create OAuth provider.",
    oauth_use_external_provider: "Use external provider",
    oauth_authorization_invalid: "Login authorization failed.",
    oauth_login_failed: "Login failed.",
    oauth_registration_closed: "Registration closed.",
    oauth_registration: "Allow registration via OAuth",
    community_locked_message: "<1>Community locked:</1> only moderators can create posts. You can still comment on posts.",
    community_locked: "Community locked",
    community_visibility: "Visibility",
    community_visibility_public: "Public",
    community_visibility_public_desc: "This community is visible to everyone.",
    community_visibility_unlisted: "Unlisted",
    community_visibility_unlisted_desc: "This community is visible to everyone, but not shown in global/all feeds.",
    community_visibility_local_only_public: "Local only (public)",
    community_visibility_local_only_public_desc: "This community does not federate and is only available to local users (including those who are not logged in).",
    community_visibility_local_only_private: "Local only (private)",
    community_visibility_local_only_private_desc: "This community does not federate and is only available to local users who are logged in.",
    community_visibility_private: "Private",
    community_visibility_private_desc: "This community is private and can only by viewed by users who were manually approved by the moderators.",
    public_blurb: "This community can be federated to other instances and be posted/commented in by their users.",
    private: "Private",
    private_blurb: "Only approved users can interact with this community.",
    banned_from_community_blurb: "<1>Banned:</1> You cannot post, comment, or vote in this community. However, you are still free to browse.",
    private_message_form_user_matrix_blurb: "This user already has a matrix account you can message at <1>{{matrix_id}}</1>.",
    hide_post: "Hide post",
    unhide_post: "Unhide post",
    show_content: "Show content",
    show_hidden_posts: "Show hidden posts",
    hide_hidden_posts: "Hide hidden posts",
    post_hidden: "Post hidden",
    post_unhidden: "Post unhidden",
    hidden: "Hidden",
    block_urls: "Block URLs",
    block_urls_placeholder: "Put your blocked URLs here, one URL per line. Regex strings work also, IE *.example.com",
    content_warning: "Content warning",
    sending_back_message: "Alright 👍. Sending you back in {{seconds}}.",
    continue: "Continue",
    go_back: "Go back",
    content_warning_setting_blurb: "Setting a content warning will display a prompt with the content warning asking the user for their consent to continue.",
    user_moderation_history: "{{user}} moderation history",
    comment_moderation_history: "Comment moderation history",
    post_moderation_history: "Post moderation history",
    language_not_allowed: "Language not allowed",
    edited_post: "Edited post",
    leave_admin_team_confirmation: "Are you sure you want to leave the admin team?",
    leave_mod_team_confirmation: "Are you sure you want to leave the mod team?",
    leaving_admin_team: "Leaving admin team",
    leaving_mod_team: "Leaving mod team",
    torrent_help: "Lemmy can use a technology called BitTorrent to view or stream media. <1>Click here</1> to learn how.",
    registration_for_user: "Registration for {{name}}",
    loading_registration: "Loading registration",
    fetch_registration_error: "Could not fetch registration application",
    view_registration: "View registration",
    publish_in_time: "Publish {{time}}",
    scheduled_publish_time: "Scheduled publish time",
    estimated_approval_time: "Estimated approval: {{time}}",
    post_title_only: "Post title only",
    post_url_only: "Post URL only",
    donation_dialog_title: "Support Lemmy development",
    donation_dialog_message: "An open source project the size of Lemmy needs constant work to manage the project, implement new features and fix bugs. Dessalines and Nutomic work full-time on these tasks and more. As there is no advertising or tracking, all of our work is funded through donations. Even so there is barely enough time in the day, and no time for a second job. The only available option are user donations. To keep it viable donations need to reach a minimum of 5000€ per month, resulting in a modest salary of 2500€ per developer. If that goal is reached we can stop worrying about money, and fully focus on improving the software for the benefit of all users and instances. We especially rely on recurring donations to secure the long-term development and make Lemmy the best it can be.<br/><br/>If you want more information before donating, consider the comparison with Reddit. It began as startup funded by rich investors. The site is managed by corporate executives who over time have become more and more disconnected from normal users. Their main goal is to make investors happy and to make a profit. This leads to user-hostile decisions like firing the employee responsible for AMAs, blocking third-party apps and more. As Reddit is a single website under a single authority, it means all users need to follow the same rules, including ridiculous ones like censoring the name \"Luigi\".<br/><br/>Lemmy represents a new type of social media which is the complete opposite of Reddit. It is split across many different websites, each with its own rules, and managed by normal people who actually care about the users. There is no company and no profit motive. Much of the work is carried out by volunteer admins, mods and posters, who contribute out of enthusiasm and not for money. For users this is great as there is no advertising nor tracking, and no chance of takeover by a billionaire. Additionally there are no builtin political or ideological restrictions. You can use the software for any purpose you like, add your own restrictions or scrutinize its inner workings. Lemmy truly belongs to everyone.<br/><br/>Nutomic and Dessalines, Lemmy Developers",
    donation_dialog_button_donate: "Donate",
    donation_dialog_button_hide: "Hide",
    disable: "Disable",
    post_upvote_federation: "Post upvote federation",
    post_downvote_federation: "Post downvote federation",
    comment_upvote_federation: "Comment upvote federation",
    comment_downvote_federation: "Comment downvote federation",
    added_item_to_list: "Added {{item}} to {{list}}",
    removed_item_from_list: "Removed {{item}} from {{list}}",
    allowlist: "allowlist",
    blocklist: "blocklist",
    mark_page_as_read: "Mark page as read",
    image_uploaded: "Image uploaded",
    image_deleted: "Image deleted",
    subscribers_local: "Local subscribers",
    active_daily: "Active daily",
    active_weekly: "Active weekly",
    active_monthly: "Active monthly",
    active_six_months: "Active six months",
    name_asc: "Name ascending",
    name_desc: "Name descending",
    image: "Image",
    upload: "Upload",
    enable_private_messages: "Enable private messages",
    auto_mark_fetched_posts_as_read: "Automatically mark fetched post as read",
    upload_and_publish_image_title: "Upload this image?",
    upload_and_publish_image_desc: "The uploaded image will be distributed to federated instances without any further user interactions.",
    vote_show: "Show",
    vote_show_for_others: "Show for others",
    vote_hide: "Hide",
    multi_communities: "Multi-communities",
    create_multi_community: "Create multi-community",
    liked: "Liked",
    none: "None",
    back_to_first_page: "First page",
    posts_per_page: "Posts per page",
    note_created: "Note created",
    note_deleted: "Note deleted",
    show_user_vote_totals: "Show user vote totals",
    vote_totals_for_user: "Vote totals for user",
    note_for_user: "Note for user",
    create_user_note: "Create user note",
    new_account_label: "New account, created within the last 7 days",
    last_updated: "Last updated",
    notification_mode_all_posts_and_comments: "All posts and comments",
    notification_mode_all_posts: "All posts",
    notification_mode_all_comments: "All comments",
    notification_mode_replies_and_mentions: "Replies and mentions (default)",
    notification_mode_mute: "Mute",
    notifications_updated: "Notifications updated",
    unknown_language: "Unknown language",
    registered_date_title: "Registered",
    ban_person_button: "Ban {{name}}",
    banned_dialog_title_permanent: "You have been permanently banned",
    banned_dialog_title_temporary: "You have been temporarily banned (expires {{expires}})",
    banned_dialog_body: "You cannot post, vote or take other actions. However you can continue to browse the site, and on the settings page export your settings to import on another Lemmy instance, create a backup or delete your account.",
    cant_view_private_community_message: "You don't have permission to view this community. Click the subscribe button and wait for manual approval by a moderator to see the content.",
    expand_all_images: "Expand all images",
    show_animated_images: "Show animated images",
    hide_memes: "Hide memes",
    hide_memes_description: "Hides posts with images or videos from feed.",
    hide_community_reports: "Hide community reports",
    show_community_reports: "Show community reports",
    community_pending_follows: "Pending follows",
    pending_private_community_follows: "{{formattedCount}} pending follow",
    pending_private_community_follows_plural: "{{formattedCount}} pending follows",
    block_keyword_too_short: "Block keyword too short",
    block_keyword_too_long: "Block keyword too long",
    couldnt_update: "Couldnt update",
    couldnt_create: "Couldnt create",
    cant_block_yourself: "Cant block yourself",
    cant_note_yourself: "Cant note yourself",
    cant_block_admin: "Cant block admin",
    passwords_do_not_match: "Passwords dont match",
    pictrs_api_key_not_provided: "Pictrs API key missing",
    no_content_type_header: "No content-type header",
    not_an_image_type: "Not an image filetype",
    invalid_image_upload: "Invalid image uploaded",
    image_upload_disabled: "Image upload disabled",
    not_top_mod: "You are not the top mod",
    not_higher_mod: "Cannot make changes to higher ranked moderator",
    not_higher_admin: "Cannot make changes to higher ranked admin",
    person_is_blocked: "Person is blocked",
    community_is_blocked: "Community is blocked",
    instance_is_blocked: "Instance is blocked",
    honeypot_failed: "Honeypot check failed, are you a bot?",
    registration_application_is_pending: "Registration is awaiting review by an admin",
    max_comment_depth_reached: "Maximum comment depth reached",
    already_exists: "Item already exists",
    nsfw_not_allowed: "NSFW content is not allowed on this instance",
    edit_private_message_not_allowed: "You are not allowed to edit this private message",
    application_question_required: "You must answer the application question",
    invalid_default_post_listing_type: "Cannot use subscribed or moderator-view as your default post listing",
    registration_username_required: "Username is required for registration",
    email_already_taken: "This email is already taken",
    username_already_taken: "This username is already taken",
    person_is_banned_from_community: "You are banned from this community",
    no_id_given: "Either name or id must be provided",
    local_site_not_setup: "Local site not setup yet",
    invalid_name: "Invalid name",
    invalid_code_verifier: "Invalid PKCE code_vierifier for OAuth",
    invalid_display_name: "Invalid displayname",
    invalid_body_field: "Text is too long or too short",
    alt_text_length_overflow: "Alt text is too long",
    missing_alt_text: "Consider writing a short text description (alt text) to this image or media to help visually impaired readers.",
    couldnt_parse_totp_secret: "Failed to parse TOTP secret",
    couldnt_generate_totp: "Failed to generate TOTP",
    missing_totp_token: "Missing TOTP token",
    missing_totp_secret: "Missing TOTP secret",
    incorrect_totp_token: "Incorrect TOTP token",
    totp_already_enabled: "TOTP is already enabled for your account",
    blocked_url: "URL is blocked on this instance",
    email_send_failed: "Failed to send email",
    slurs: "Text contains a slur which is blocked by this instance",
    couldnt_create_image_captcha: "Failed to create image captcha",
    invalid_url_scheme: "Invalid URL scheme, only http, https and magnet are allowed",
    contradicting_filters: "Cant use filters 'liked only' and 'disliked only' together",
    too_many_items: "Too many items",
    ban_expiration_in_past: "Ban expiration time is in the past",
    invalid_unix_time: "Invalid unix timestamp",
    invalid_bot_action: "Bots are not allowed to vote",
    tag_not_in_community: "The tag not allowed in this community",
    cant_block_local_instance: "Cant block the local instance",
    url_length_overflow: "URL is too long",
    not_found: "Not found",
    post_schedule_time_must_be_in_future: "Post schedule time must be in the future",
    too_many_scheduled_posts: "You cant have more than 10 active scheduled posts at once",
    cannot_combine_federation_blocklist_and_allowlist: "",
    couldnt_parse_pagination_token: "Invalid pagination token",
    invalid_fetch_limit: "Invalid fetch limit",
    email_notifications_disabled: "Email notifications are disabled on this instance",
    multi_community_update_wrong_user: "You are not allowed to update this multi-community",
    cannot_combine_community_id_and_multi_community_id: "",
    multi_community_entry_limit_reached: "Maximum number of entries reached for multi-community",
    too_many_requests: "Too many requests",
    cannot_leave_mod: "Cannot leave mod",
    tags: "Tags",
    color: "Color",
    summary: "Summary",
    active_plugins: "Active plugins",
    community_not_federated_title: "Community not federated yet",
    community_not_federated_message: "Only local users are currently following this community. To get more followers, promote it across the Lemmyverse and share the identifier <1>communityName</1>. You can also use <2>lemmy-federate.com</2>.",
    dead_community_title: "Dead community",
    dead_community_body: "This community has not federated for more than a week. New posts and comments will probably be missing. It is likely that the instance is down or defederated.",
    suggested_multi_community: "Suggested Multi-Community",
    image_mode: "Image mode",
    store_link_previews: "Store link previews",
    proxy_all_images: "Proxy all images",
    image_proxy_bypass_domains: "Image Proxy Bypass domains",
    image_upload_timeout_seconds: "Image upload timeout (in seconds)",
    image_max_thumbnail_size: "Maximum thumbnail size (pixels)",
    image_max_avatar_size: "Maximum avatar size for users and communities (pixels)",
    image_max_banner_size: "Maximum banner size for users and communities (pixels)",
    image_max_upload_size: "Maximum size for post/comment images (pixels)",
    image_allow_video_uploads: "Allow video uploads",
    federation_signed_fetch: "Federation signed fetch",
    private_community_sidebar_warning: "The sidebar of private communities is publicly visible. Do not put any sensitive information here, instead use a featured post.",
    invalid_invite_token: "Invalid invite token",
    missing_invite_token: "Missing invite token",
    too_many_invites: "Too many invites",
    children_for_modlog_item: "Children for modlog item",
    modlog_view_children: "View children",
  },
} as const;